import DocumentVerificationNegativeStepperControls from './DocumentVerificationNegativeStepperControls';

export default DocumentVerificationNegativeStepperControls;
